import { useTranslation } from 'react-i18next'

import { Box as DarkBox, Toggle } from '@hivewatch/dark'

import { darkAssociateModalStyles } from './DarkAssociateDeviceModal.styles'

interface DarkEnableTailgateBoxIProps {
  colorScheme: 'dark' | 'light'
  isDisabled: boolean
  isEnabled: boolean
  isLoading: boolean
  onToggleChange: (isTailgateEnabled: boolean) => void
}

// Dark Toggle carries no visible label, so title/description are composed
// beside it (prior art: incident-drawer ResolveToggle).
export const DarkEnableTailgateBox = ({
  colorScheme,
  isDisabled,
  isEnabled,
  isLoading,
  onToggleChange,
}: DarkEnableTailgateBoxIProps) => {
  const { t } = useTranslation()
  const s = darkAssociateModalStyles(colorScheme)

  return (
    <DarkBox
      {...s.tailgateBox}
      data-testid='DarkAssociateDeviceModal:tailgateBox'
      opacity={isDisabled ? 0.5 : 1}
    >
      <DarkBox>
        <DarkBox {...s.tailgateTitle}>
          {isEnabled
            ? t('floors:tailgate_enabled_title')
            : t('floors:tailgate_enable_title')}
        </DarkBox>
        <DarkBox {...s.tailgateDescription}>
          {isDisabled
            ? t('floors:tailgate_requires_grids')
            : t('floors:tailgate_enable_description')}
        </DarkBox>
      </DarkBox>
      <DarkBox {...s.tailgateControls}>
        <Toggle
          aria-label={t('floors:tailgate_enable_title')}
          colorScheme={colorScheme}
          data-testid='DarkAssociateDeviceModal:tailgateToggle'
          disabled={isLoading || isDisabled}
          isOn={isEnabled}
          onChange={onToggleChange}
        />
      </DarkBox>
    </DarkBox>
  )
}
